import React from 'react'
import { IActiveTask, TaskStatus, TASK_STATUS_MAP } from '../types/operations.types'
import { OpsTableRow, Badge, MonoText } from '../styled/Operations.styled'
import { SourceBadge } from './SourceBadge'

interface TaskRowProps {
  task: IActiveTask
}

export const TaskRow: React.FC<TaskRowProps> = ({ task }) => {
  const isBlocked = task.status === TaskStatus.Stopped
  const statusConfig = TASK_STATUS_MAP[task.status]

  return (
    <OpsTableRow blocked={isBlocked}>
      <td style={{ fontWeight: 700 }}>{task.name}</td>
      <td style={{ color: '#D4C8B8' }}>{task.machine || '-'}</td>
      <td style={{ color: '#D4C8B8' }}>{task.operator || '-'}</td>
      <td>
        <Badge bg={statusConfig?.color || '#8A8078'}>{task.statusLabel}</Badge>
      </td>
      <td><MonoText>{task.eta || '-'}</MonoText></td>
      <td style={{ color: '#D4C8B8' }}>{task.location}</td>
      <td><SourceBadge source={task.source} /></td>
    </OpsTableRow>
  )
}
